<template>
  <div class="logo-wrapper">
    <svg
        viewBox="0 0 1280 336"
        class="logo"
        :class="phase"
    >
      <defs>
        <linearGradient id="red3d" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="#FF5F5F" />
          <stop offset="40%" stop-color="#E60000" />
          <stop offset="100%" stop-color="#8B0000" />
        </linearGradient>
        <linearGradient id="gloss" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#FFFFFF" stop-opacity="0.6" />
          <stop offset="50%" stop-color="#FFFFFF" stop-opacity="0" />
          <stop offset="100%" stop-color="#000000" stop-opacity="0.1" />
        </linearGradient>
        <linearGradient id="planeBody" x1="303.65344" y1="666.67157" x2="388.522" y2="751.5401" gradientTransform="scale(1.5814806,0.63231886)" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#FFEFEF" />
          <stop offset="100%" stop-color="#E0E6ED" />
        </linearGradient>
        <linearGradient id="planeFold" x1="552.39026" y1="439.06332" x2="636.42413" y2="439.06332" gradientTransform="scale(0.95447513,1.0476962)" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#BCCBDD" />
          <stop offset="100%" stop-color="#E0E6ED" />
        </linearGradient>
        <filter id="softShadow" x="-0.018443724" y="-0.031793037" width="1.0426511" height="1.0735214">
          <feGaussianBlur in="SourceAlpha" stdDeviation="4" result="blur" />
          <feOffset in="blur" dx="3" dy="3" result="offsetBlur" />
          <feComponentTransfer>
            <feFuncA type="linear" slope="0.5" />
          </feComponentTransfer>
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient id="lGrad2" x1="619.86768" y1="307.45712" x2="619.86768" y2="541.36096" gradientTransform="scale(0.83021888,1.2045016)" gradientUnits="userSpaceOnUse" xlink:href="#red3d" />
        <linearGradient id="lGrad3" x1="619.86768" y1="307.45712" x2="853.77155" y2="541.36096" gradientTransform="scale(0.83021888,1.2045016)" gradientUnits="userSpaceOnUse" xlink:href="#gloss" />
        <linearGradient id="lGrad4" x1="1423.8668" y1="203.91154" x2="1423.8668" y2="327.47437" gradientTransform="scale(0.50262893,1.9895393)" gradientUnits="userSpaceOnUse" xlink:href="#red3d" />
        <linearGradient id="lGrad5" x1="1423.8668" y1="203.91154" x2="1547.4296" y2="327.47437" gradientTransform="scale(0.50262893,1.9895393)" gradientUnits="userSpaceOnUse" xlink:href="#gloss" />
        <linearGradient id="lGrad6" x1="794.65466" y1="441.82516" x2="794.65466" y2="644.39166" gradientTransform="scale(0.98905385,1.0110673)" gradientUnits="userSpaceOnUse" xlink:href="#red3d" />
        <linearGradient id="lGrad7" x1="794.65466" y1="441.82516" x2="997.22113" y2="644.39166" gradientTransform="scale(0.98905385,1.0110673)" gradientUnits="userSpaceOnUse" xlink:href="#gloss" />
      </defs>

      <!-- BET -->
      <path id="path-bet" class="bet-text" d="m 600.6097,61.456176 c -17.97704,1.056855 -38.42975,2.639042 -56.26082,2.718858 0.6715,17.158095 0.9487,38.906566 2.83223,55.586556 -7.57458,0.48743 -15.19321,1.07305 -22.77939,1.15997 0.66401,14.13851 1.12986,29.58914 2.26821,43.59149 -7.93679,-12.34655 -15.92565,-21.84949 -28.23156,-30.10529 -33.13609,-22.22773 -77.6123,-24.51675 -111.38441,-2.23265 -24.91215,16.43651 -38.24197,39.21554 -44.1232,68.16768 -0.68143,3.34749 -1.27922,6.71204 -1.79182,10.08964 -2.40657,-12.02958 -4.85312,-22.33361 -10.52883,-33.41072 -26.95847,-52.61297 -105.67366,-81.361104 -144.93723,-24.98801 -1.53638,-24.00348 -2.70122,-48.02928 -3.49,-72.069467 -0.67382,-17.749371 -1.56658,-35.319748 -1.6592,-53.085733 -18.72698,0.527666 -37.44508,1.318548 -56.14978,2.374816 2.8179,70.13832 5.99691,140.261794 9.53475,210.368134 0.8747,18.3595 1.87359,36.71407 2.99839,55.05916 0.63406,10.81749 1.64619,23.37367 1.69087,34.1508 16.98847,-0.83044 33.67817,-1.8906 50.69104,-2.53163 -0.40542,-7.75571 -0.66274,-16.75604 -1.38256,-24.39671 28.30509,28.74163 66.04838,33.34702 101.13148,13.66118 33.11115,-22.5622 44.97159,-42.06681 52.47333,-81.63984 l 0.44775,-2.42848 c 4.07271,28.74213 16.24106,52.20312 39.78681,69.83325 21.42433,16.04771 48.34427,22.93445 74.84317,19.14323 32.57878,-4.75669 54.31986,-21.3469 70.9056,-49.20698 l -46.13546,-22.8724 c -3.76201,5.77121 -7.40136,11.75301 -13.11965,15.79754 -27.85608,19.70428 -62.48822,3.16964 -73.52727,-26.72978 47.56776,-3.66998 97.45559,-4.10632 145.19715,-7.39659 -0.14186,-26.31346 -1.08181,-33.36047 -8.958,-58.75865 6.0803,-0.52511 12.16834,-0.94686 18.2633,-1.26562 0.95803,16.13701 1.75168,32.28217 2.38026,48.43557 1.21438,28.2143 0.0945,59.33922 23.39411,79.67249 18.53636,16.17776 43.45133,15.71551 66.56629,14.12887 -1.1858,-17.5742 -2.06138,-35.16781 -2.62324,-52.77359 -8.71328,-1.13817 -18.6198,-2.1863 -24.4741,-9.66277 -8.59001,-10.96996 -7.87598,-65.65814 -8.24093,-81.94884 12.8147,-0.72343 25.89308,-1.9359 38.65918,-1.99183 -2.08685,-16.03685 -1.64434,-34.49173 -2.79932,-50.82573 -13.65269,1.37901 -25.28386,1.28283 -38.4464,2.23976 -0.57595,-14.54579 -1.62386,-39.549604 -1.84806,-54.880893 -0.2614,-0.291038 -0.52171,-0.58415 -0.7818,-0.876122 z M 452.85455,163.34484 c 16.11113,3.62118 26.77097,14.72678 34.06421,30.45281 l -51.44523,2.49117 c -12.76325,1.00188 -27.03688,1.42425 -39.98086,2.16577 9.57892,-25.12979 22.38149,-36.36278 50.11772,-36.19487 2.53016,0.20348 4.94257,0.56782 7.24415,1.08517 z M 242.6902,174.85839 c 25.35103,3.4536 44.46387,25.62738 43.54617,51.74812 -0.97774,27.86231 -24.3735,49.64794 -52.23474,48.64258 -27.82326,-1.00375 -49.57086,-24.35722 -48.59473,-52.18157 0.97706,-27.82303 24.31068,-49.59716 52.13593,-48.64754 1.74142,0.0594 3.4573,0.20815 5.14737,0.43841 z" fill="#4a4a4a" style="filter:url(#softShadow)" />

      <!-- TRAIL -->
      <g id="trail-group" class="trail">
        <path class="trail-segment trail-1" d="m 199.60734,200.55009 c 2.2215,-1.4675 42.23388,-25.80325 42.23388,-25.80325 1.6717,0.23303 3.35442,0.43303 4.96378,0.85309 0,0 -43.77066,27.93216 -46.14766,29.47966 -12.659,8.4675 -25.723,17.605 -38.316,26.285 -14.113,9.8025 -43.3765,27.577 -60.1635,30.2035 -15.047304,2.249 -24.907754,-2.9475 -15.078854,-18.671 7.333351,-10.092 28.810854,-22.701 40.368354,-26.812 l 0.127,-0.044 c -14.2075,9.596 -29.366593,16.24 -38.336593,32.744 -2.531415,4.56984 2.60382,9.06124 8.95407,8.41268 17.511503,0.0975 50.158523,-21.26168 64.391523,-31.62218 4.1075,-2.394 11.268,-7.6005 15.2925,-10.394 7.1675,-4.98 14.4055,-9.8575 21.7115,-14.6315 z" fill="#BCCBDD" />
        <path class="trail-segment trail-2" d="m 433.3886,196.52526 c 0,0 -5.75346,-10.77853 -8.05312,-16.42636 -2.36271,-5.80266 -3.63518,-12.0024 -5.86847,-17.85608 -2.26668,-5.94118 -4.66922,-11.85668 -7.62887,-17.4848 -2.9943,-5.694 -5.95679,-11.54881 -10.20012,-16.38426 -3.58565,-4.08599 -7.97506,-7.50053 -12.60802,-10.34443 -5.36561,-3.29363 -11.20175,-6.00219 -17.29212,-7.59754 -5.87545,-1.53905 -12.06024,-1.90224 -18.13288,-1.79015 -5.79799,0.10702 -11.59546,1.00859 -17.23788,2.34692 -5.33843,1.26623 -10.50864,3.22078 -15.56907,5.34075 -6.05384,2.53613 -12.02173,5.36437 -17.61788,8.79423 -4.62694,2.83584 -13.53288,9.50952 -13.09036,9.67972 -2.00737,-1.16781 -1.7042,-0.96928 -3.5706,-2.00781 0,0 10.35017,-8.05696 15.91493,-11.50373 5.60554,-3.47204 11.40933,-6.70449 17.51615,-9.19121 5.22353,-2.12704 10.68974,-3.6979 16.21267,-4.84106 5.72717,-1.18543 11.57565,-1.9821 17.42362,-2.06619 6.33296,-0.0911 12.78633,0.13542 18.92517,1.69406 6.46183,1.64065 12.68841,4.42963 18.35875,7.93595 5.17684,3.20116 10.0118,7.13452 13.97052,11.7579 4.47242,5.22333 7.52863,11.53644 10.69506,17.64049 2.83497,5.46508 5.18092,11.18006 7.39671,16.92415 2.35746,6.11137 3.69658,12.5994 6.26152,18.62664 2.41654,5.67853 8.55583,16.41849 8.55583,16.41849 z" fill="#BCCBDD" />
        <path class="trail-segment trail-3" d="m 456.08373,234.09428 c 0,0 8.66355,11.5625 13.96034,16.41349 6.87698,6.29819 14.4579,12.05397 22.81742,16.18658 8.90488,4.40222 18.70737,6.94844 28.45878,8.84223 8.56171,1.66274 17.35463,2.17924 26.07627,2.15334 8.21499,-0.0244 16.43518,-0.88856 24.549,-2.17411 7.57773,-1.20062 15.19747,-2.60115 22.43179,-5.15617 6.103,-2.15546 12.16898,-4.76913 17.45823,-8.4996 6.01367,-4.24139 11.99962,-9.1321 15.76496,-15.45475 2.69543,-4.52607 4.10772,-9.93064 4.35106,-15.19291 0.27118,-5.86428 -0.49334,-12.13149 -3.26562,-17.30621 -2.4001,-4.48001 -6.56646,-8.01061 -10.90735,-10.65403 -3.29192,-2.00464 -7.9642,-2.24999 -10.97467,-3.64067 l -0.11501,-3.73647 c 5.69626,1.76566 8.5722,2.10197 12.27909,4.36713 4.9411,3.01934 9.88182,6.82137 12.64743,11.90883 3.10818,5.71763 3.84113,12.70771 3.50273,19.20675 -0.30454,5.84875 -1.95694,11.81835 -4.93038,16.86407 -4.1328,7.01307 -10.55077,12.63358 -17.1849,17.35073 -5.27359,3.74975 -11.3936,6.27179 -17.5135,8.37373 -7.39979,2.54153 -15.19536,3.83349 -22.92846,5.02317 -8.32665,1.28099 -16.74792,2.21518 -25.17239,2.26197 -8.97066,0.0498 -18.00341,-0.50595 -26.82949,-2.11077 -9.72004,-1.76737 -19.54997,-3.98687 -28.47404,-8.22524 -8.92724,-4.23988 -17.11585,-10.17226 -24.37637,-16.87726 -6.24071,-5.76322 -16.12512,-19.73403 -16.12512,-19.73403 z" fill="#BCCBDD" />
        <path class="trail-segment trail-4" d="m 661.17093,145.37553 c 0,0 -30.5102,-0.73828 -44.93997,-5.10621 -5.34592,-1.61822 -10.08764,-4.82991 -14.90343,-7.65935 -4.64967,-2.73184 -9.00609,-5.93535 -13.46419,-8.96976 -6.04078,-4.11165 -11.57395,-9.0334 -17.99875,-12.51459 -5.87854,-3.18521 -12.04035,-6.17871 -18.58569,-7.54304 -6.55635,-1.36662 -13.69138,-2.50428 -20.08529,-0.51147 -4.7846,1.49122 -9.19728,4.80562 -12.151,8.85428 -2.86966,3.93345 -4.24883,9.01057 -4.58791,13.86773 -0.48073,6.88614 1.25233,13.923 3.70956,20.37374 -2.37635,6.23843 5.96889,12.13065 10.43036,17.09657 5.93885,6.61035 13.44907,12.67786 21.1464,16.2336 l 0.19328,3.31388 c -12.56198,-5.39003 -16.91712,-9.67135 -23.47927,-16.6784 -4.90173,-5.23405 -8.63107,-11.65402 -11.28266,-18.31669 -2.77164,-6.96432 -5.06958,-14.53384 -4.58722,-22.01388 0.37517,-5.81777 2.24723,-11.85202 5.73736,-16.52173 3.45439,-4.62189 8.55465,-8.39738 14.07488,-10.077192 6.94472,-2.113284 14.67754,-0.893653 21.76724,0.665593 6.64062,1.460479 12.81487,4.704649 18.76866,7.988439 6.56528,3.62105 12.31583,8.55462 18.49211,12.80532 4.3557,2.99772 8.57866,6.20233 13.09289,8.95554 4.74121,2.89164 9.41407,6.09007 14.65723,7.92035 14.06375,4.90937 43.99541,7.83727 43.99541,7.83727 z" fill="#BCCBDD" />
      </g>

      <!-- i -->
      <path id="path-i" class="letter-i" d="M 722.56333,650.52307 V 483.83669 h 48.33285 v 166.68638 z m 24.16643,-189.92333 q -13.32252,0 -21.68782,-7.74565 -8.3653,-7.74565 -8.3653,-19.20921 0,-11.46356 8.3653,-19.20921 8.3653,-7.74565 21.68782,-7.74565 13.32252,0 21.68782,7.43582 8.3653,7.126 8.3653,18.58956 0,12.08321 -8.3653,20.13869 -8.05548,7.74565 -21.68782,7.74565 z" fill="url(#lGrad4)" stroke="url(#lGrad5)" stroke-width="2" transform="matrix(1.0814552,-0.03776529,0.03776529,1.0814552,68.565991,-371.16131)" />
      
      <!-- c -->
      <path id="path-c" class="letter-c" d="m 896.78025,650.52331 q -31.84895,0 -56.74239,-12.8128 -24.89344,-13.17888 -39.17056,-36.24192 -13.91104,-23.06304 -13.91104,-52.34944 0,-29.65248 13.91104,-52.34944 14.27712,-23.06304 39.17056,-35.87584 24.89344,-13.17888 56.74239,-13.17888 31.1168,0 54.17984,13.17888 23.06304,12.8128 34.04544,36.97408 l -44.29568,23.7952 q -7.68768,-13.91104 -19.40224,-20.50048 -11.34848,-6.58944 -24.89344,-6.58944 -14.64319,0 -26.35775,6.58944 -11.71456,6.58944 -18.67008,18.67008 -6.58944,12.08064 -6.58944,29.2864 0,17.20576 6.58944,29.2864 6.95552,12.08064 18.67008,18.67008 11.71456,6.58944 26.35775,6.58944 13.54496,0 24.89344,-6.22336 11.71456,-6.58944 19.40224,-20.86656 l 44.29568,24.16128 q -10.9824,23.7952 -34.04544,36.97408 -23.06304,12.8128 -54.17984,12.8128 z" fill="url(#lGrad6)" stroke="url(#lGrad7)" stroke-width="2" transform="matrix(1.0814552,-0.03776529,0.03776529,1.0814552,68.565991,-371.16131)" />

      <!-- P + PLANE Group -->
      <g id="p-plane-group" class="p-plane" transform="matrix(1.0814552,-0.03776529,0.03776529,1.0814552,68.565991,-371.16131)">
        <!-- P -->
        <path d="m 634.4996,372.95327 c 16.45317,2.93755 34.27636,12.71824 46.09924,24.39926 18.35136,18.13253 27.19478,41.42204 27.46564,67.00898 0.19058,24.70981 -9.48715,48.47399 -26.88595,66.02122 -29.41658,29.68394 -60.5043,27.70004 -99.00883,28.00005 0.60812,10.35176 0.45034,23.55077 0.56258,33.99474 0.12603,19.1677 0.45202,38.33247 0.98022,57.49368 -7.68775,-0.25654 -15.88414,0.1951 -23.61812,0.21699 -12.58174,0.0362 -25.35034,0.0317 -37.88037,1.17323 -1.39402,-7.38353 -1.00859,-15.32664 -1.3083,-22.85242 -0.59353,-14.89844 -0.25035,-30.52791 -1.24051,-45.35622 -0.29801,-2.13747 0.55088,-3.38614 2.18939,-4.64431 8.3458,-6.40442 17.13707,-12.30127 25.71655,-18.40984 17.80093,-12.81662 35.52282,-25.74396 53.16211,-38.78056 11.2143,-8.22804 22.73282,-16.29689 33.29885,-25.56248 16.59567,-14.28397 16.40598,-44.50226 1.09529,-59.52722 -13.99257,-13.73324 -41.02639,-10.93187 -59.30812,-10.83369 -0.2148,6.34807 0.20738,13.83271 0.649,20.15855 -18.90374,-9.0096 -41.12049,-17.8129 -60.596,-26.43303 -0.80257,-14.41564 -0.38889,-32.57946 -0.39289,-47.30667 5.01972,-0.25353 11.92426,0.0179 17.18622,-0.0305 l 39.20009,-0.30791 c 18.59375,-0.0797 44.85187,-1.19742 62.63391,1.57817 z" fill="url(#lGrad2)" stroke="url(#lGrad3)" stroke-width="1.5" />
        
        <!-- PLANE ICON -->
        <g transform="matrix(1.0364726,0.2082,-0.2082,1.0364726,85.940725,-114.10061)">
          <path d="m 480.222,421.549 c 4.761,0.505 11.497,2.238 16.352,3.336 l 26.979,6.106 90.887,20.265 c -6.324,1.832 -12.675,3.568 -19.051,5.21 -22.305,6.074 -44.561,12.324 -66.768,18.747 -12.013,-12.471 -23.797,-25.16 -35.346,-38.062 -2.693,-3.01 -11.3,-12.392 -13.053,-15.602 z" fill="url(#planeBody)" />
          <path d="m 606.354,460.024 0.661,-0.019 0.436,0.459 c -1.078,2.312 -17.459,19.64 -20.394,22.892 l -35.954,39.845 c -7.134,7.884 -15.59,17.584 -23.154,24.846 l -0.694,-0.796 c -0.171,-4.144 1.493,-13.61 2.051,-18.253 1.654,-13.75 3.901,-27.68 5.345,-41.442 23.013,-9.359 48.395,-18.669 71.703,-27.532 z" fill="url(#planeFold)" />
        </g>
      </g>
    </svg>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue'

const props = defineProps<{ isLoaded: boolean }>()
const emit = defineEmits<{ (e: 'animation-complete'): void }>()

type Phase = 'idle' | 'p-only' | 'expanding' | 'settled' | 'collapsing' | 'exit'
const phase = ref<Phase>('idle')

let animationTimer: ReturnType<typeof setTimeout> | null = null
const clearTimer = () => { if (animationTimer) { clearTimeout(animationTimer); animationTimer = null } }
const after = (ms: number, fn: () => void) => { animationTimer = setTimeout(fn, ms) }

const pendingReverse = ref(false)

const playForward = () => {
  clearTimer()
  phase.value = 'idle'
  
  // Trigger the drop almost immediately
  after(50, () => {
    phase.value = 'p-only'
    
    // Wait for drop and bounce to settle (1.2s transition)
    after(1500, () => {
      phase.value = 'expanding'
      // Wait for full expansion (1.2s transition)
      after(1300, () => {
        phase.value = 'settled'
        
        // Immediately check if we should reverse (no forced delay, matching AskOdds/AskBookmaker)
        if (props.isLoaded || pendingReverse.value) {
          pendingReverse.value = false
          playReverse()
        }
      })
    })
  })
}

const playReverse = () => {
  clearTimer()
  phase.value = 'collapsing'
  // 0.8s for elements to fade + 1.2s for the P to shift back
  after(2000, () => {
    phase.value = 'exit'
    after(800, () => {
      phase.value = 'idle'
      emit('animation-complete')
    })
  })
}

onMounted(() => {
  playForward()
})

watch(() => props.isLoaded, (loaded) => {
  if (!loaded) return
  if (phase.value === 'settled') {
    // Already in settled state, trigger reverse immediately
    playReverse()
  } else {
    // Still in intro phases, mark for reverse once settled
    pendingReverse.value = true
  }
})
</script>

<style scoped>
.logo-wrapper {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000;
  z-index: 9999;
}

.logo {
  width: auto;
  height: 25%;
  max-width: 90vw;
  overflow: visible;
  /* Default transition for intro expansion */
  transition: transform 1.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.logo.collapsing, .logo.exit {
  /* Delay the centering shift during outro until wordmark has mostly faded (0.8s) */
  transition: transform 1.2s cubic-bezier(0.22, 1, 0.36, 1) 0.8s;
}

/* Base states - Uniform duration for intro and outro */
.bet-text, .letter-i, .letter-c {
  opacity: 0;
  transition: all 1.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.trail {
  opacity: 1;
  transition: transform 1.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.trail-segment {
  opacity: 0;
  transition: opacity 0.4s ease-out;
}

.p-plane {
  opacity: 1;
  /* Static P position within the SVG */
  transform: matrix(1.08, -0.037, 0.037, 1.08, 68.56, -371.16);
  /* Added bounce easing for the drop */
  transition: transform 1.2s cubic-bezier(0.175, 0.885, 0.32, 1.275), opacity 0.5s ease;
}

/* PHASES */

/* IDLE: P is off-screen at the top */
.logo.idle .p-plane {
  transform: matrix(1.08, -0.037, 0.037, 1.08, 68.56, -371.16) translateY(-800px);
  opacity: 0;
}

/* P-ONLY: P is DEAD CENTER on screen (dropped into position) */
.logo.p-only, .logo.collapsing, .logo.exit {
  transform: translateX(-8.828%);
}

.logo.p-only .p-plane {
  opacity: 1;
  transform: matrix(1.08, -0.037, 0.037, 1.08, 68.56, -371.16) translateY(0);
}

/* i and c flow RIGHT from behind the static P position */
.logo.p-only .letter-i {
  transform: matrix(1.08, -0.037, 0.037, 1.08, 68.56, -371.16) translateX(-150px);
}
.logo.p-only .letter-c {
  transform: matrix(1.08, -0.037, 0.037, 1.08, 68.56, -371.16) translateX(-350px);
}

/* EXPANDING: Full logo is centered, P shifts into its wordmark position */
.logo.expanding, .logo.settled {
  transform: translateX(0);
}

.logo.expanding .letter-i, .logo.expanding .letter-c,
.logo.settled .letter-i, .logo.settled .letter-c {
  opacity: 1;
  transform: matrix(1.08, -0.037, 0.037, 1.08, 68.56, -371.16) translateX(0);
}

/* BET and TRAIL flow LEFT from the static P position */
.logo.p-only .bet-text {
  transform: translateX(153px);
}
.logo.p-only .trail {
  /* Removed translateX to allow segments to fade in place without sliding */
}

.logo.expanding .bet-text,
.logo.settled .bet-text {
  opacity: 1;
  transform: translateX(0);
}

.logo.expanding .trail,
.logo.settled .trail {
  opacity: 1;
}

.logo.expanding .trail-segment,
.logo.settled .trail-segment {
  opacity: 1;
}

/* Fade in Right to Left during expansion */
.logo.expanding .trail-4 { transition-delay: 0.0s; }
.logo.expanding .trail-3 { transition-delay: 0.15s; }
.logo.expanding .trail-2 { transition-delay: 0.3s; }
.logo.expanding .trail-1 { transition-delay: 0.45s; }

/* Reverse Animation - Pull P back to DEAD CENTER */
.logo.collapsing .bet-text {
  opacity: 0;
  transform: translateX(0); /* Fade in place instead of sliding */
  transition: opacity 0.8s ease-in-out; /* Smoother, slower fade for outro */
}
.logo.collapsing .trail {
  /* Keep trail group static during collapse, segments will fade out */
}

.logo.collapsing .trail-segment {
  opacity: 0;
}

/* Fade out Left to Right during collapse */
.logo.collapsing .trail-1 { transition-delay: 0.0s; }
.logo.collapsing .trail-2 { transition-delay: 0.15s; }
.logo.collapsing .trail-3 { transition-delay: 0.3s; }
.logo.collapsing .trail-4 { transition-delay: 0.45s; }

.logo.collapsing .letter-i {
  opacity: 0;
  transform: matrix(1.08, -0.037, 0.037, 1.08, 68.56, -371.16) translateX(-150px);
}
.logo.collapsing .letter-c {
  opacity: 0;
  transform: matrix(1.08, -0.037, 0.037, 1.08, 68.56, -371.16) translateX(-350px);
}

.logo.exit {
  opacity: 0;
  transform: translateX(-8.828%);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

</style>
